<!-- Copyright 2017 VMware, Inc. All rights reserved. VMware Confidential -->
<div class="layout"
     [attr.role]="'none'">
   <ng-content></ng-content>
</div>